export class User {
  id: number;
  email: string;
  name: string;
  title_id: number | null;
  gender_id: number;
  username: string;
  password: string | null;
  salt: string | null;
  address: string | null;
  post_code: string | null;
  country_id: string | null;
  created: Date;
  last_seen: Date;
  login_count: number;
  last_modified: Date;
  phone_number: string | null;
  login_provider_id: number;
  pin: string | null;
  phone_number_verified: boolean | null;
  email_verified: boolean | null;
  created_by: number | null;
  last_modified_by: number | null;
  enable: boolean | null;
  deleted: boolean | null;
  hotel_id: number | null;
  image_url: string | null;
}
